export const LOGIN_PAGE_PATH = '/login';
export const AUTHENTICATION_TOKEN = 'authenticationToken';
export const ATTORNEY_LOCK = 'ATTORNEY_LOCK';
export const RECENT_SEARCHES = 'recentSearches';
export const AUTHORITIES = 'AUTHORITIES';
export const SUBSCRIPTION = 'SUBSCRIPTION';
export const SUBSCRIPTION_START = 'SUBSCRIPTION_START';
export const LAST_UNAUTH_TS = 'LAST_UNAUTH_TS';
export const LAST_UNAUTH_ATTEMPT = 'LAST_UNAUTH_ATTEMPT';
export const MESSAGE_DAYS_LIMIT = 'daysLimitFilterReferences';
export const MESSAGE_SORT_ASCENDING = 'messages-filter-sortAscending';
export const SESSION_ID = 'ee-session-id';
